import { render, staticRenderFns } from "./OrderAdmittancePerformerEdit.vue?vue&type=template&id=3ad63819&scoped=true&"
import script from "./OrderAdmittancePerformerEdit.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittancePerformerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad63819",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItem,QInput,QBtn,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItem,QInput,QBtn,QSeparator,QCardActions}, component.options.components || {})
